import React from 'react';
import {TextInputLabel, TextInputWrapper, Input, InputIcon} from "./input.styles";

const TextInput = ({id, placeholder, caption, value, classNames, wrapperClassNames, iconName, ...otherProps}) => {
    return (
        <TextInputWrapper className={wrapperClassNames}>
            <Input isExistIcon={!!iconName} {...{value, id, className: classNames}} {...otherProps} />
            <TextInputLabel htmlFor={id} isActive={!!value}
                            isExistIcon={!!iconName}>{placeholder}
                {
                    caption && <span>{caption}</span>
                }

            </TextInputLabel>
            {
                iconName && <InputIcon className={iconName} />
            }
        </TextInputWrapper>
    );
};

export default TextInput;
